import type React from 'react';

import { Box } from '@zillow/constellation-10';

import YesAndNo from './YesAndNo';

type Props = {
  yesHandler: () => void;
  noHandler: () => void;
  yesActive: boolean;
  className?: string;
  children?: React.ReactNode;
  disabled?: boolean;
};

export default function YesAndNoExpansion({ yesHandler, noHandler, yesActive, className, children, disabled }: Props) {
  return (
    <>
      <YesAndNo
        className={className}
        yesHandler={yesHandler}
        noHandler={noHandler}
        yesActive={yesActive}
        disabled={disabled}
      />
      {yesActive && children && <Box css={{ marginTop: 'sm' }}>{children}</Box>}
    </>
  );
}
